import React from 'react'
import ReactDOM from 'react-dom'
import _ from 'lodash'
import Sidebar from './Sidebar.jsx'
import Menu from './Menu.jsx'
import Share from './Share.jsx'
import Player from './Player.jsx'
import Loading from './Loading.jsx'

export default class App extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      playerReady: false,
      appReady: false
    }
    this.showSidebar = this.showSidebar.bind(this)
    this.showMenu = this.showMenu.bind(this)
    this.playerReady = this.playerReady.bind(this)
  }
  showSidebar(player) {
    // Don't show if player is live only
    if (player.qs.liveOnly && !this.state.showArchives)
      return false

    // Archives are disabled in the player
    if (!this.state.showArchives)
      return false

    return true
  }
  showMenu(player) {
    // Don't show if player is live only
    if (player.qs.liveOnly && this.state.showSubscribe && this.state.showSchedule)
      return false
    return true
  }
  componentDidMount(){
    this.getMeta(window.ssId, (meta) => {
      this.setState(_.extend({
        appReady: true
      }, meta))
    })
  }
  getMeta(ssId, cb) {
    $.get('/venue/'+ssId, function(response) {
      var meta = response.data.meta
      meta = _.mapValues(meta, function(n) {
        if(n === '1' || n === '0') return parseInt(n)
        return n
      })
      cb(meta)
    })
  }
  playerReady(player){
    player.getBroadcaster(player.qs.ssId, () => {
      this.setState({
        playerReady: true,
        player: player
      })
    })
  }
  render(){
    if(!this.state.appReady) return (<Loading/>)

    if(this.showSidebar(this.props.player)){
      if(this.state.playerReady){
        return(<PlayerReady player={this.state.player} showSchedule={this.state.showSchedule} showSubscribe={this.state.showSubscribe} config={this.props.player} isReady={this.playerReady} />)
      }else {
        return (<PlayerNotReady config={this.props.player} isReady={this.playerReady} />)
      }
    }else{
      if(this.state.playerReady){
        return(<PlayerReadyWithNoSideBar player={this.state.player} showSchedule={this.state.showSchedule} showSubscribe={this.state.showSubscribe} config={this.props.player} isReady={this.playerReady} />)
      }else {
        return (<PlayerNotReadyWithNoSideBar config={this.props.player} isReady={this.playerReady} />)
      }
    }
  }
}

const PlayerNotReady = (props) => {
  return (
    <div>
      <div id="ss-video-secion" className="col-md-8">
        <Player config={props.config} isReady={props.isReady} />
        <Loading/>
      </div>
      <Loading/>
    </div>
  )
}

const PlayerReady = (props) => {
  return (
    <div>
      <div id="ss-video-secion" className="col-md-8">
        <Player config={props.config} isReady={props.isReady} />

        <Menu player={props.player} showSchedule={props.showSchedule} showSubscribe={props.showSubscribe}/>
      </div>
      <div id="ss-video-secion" className="col-md-4">
        <Sidebar player={props.player}/>
      </div>
    </div>
  )
}

const PlayerNotReadyWithNoSideBar = (props) => {
  return (
    <div>
      <div id="ss-video-secion" className="col-md-8">
        <Player config={props.config} isReady={props.isReady} />
        <Loading/>
      </div>
      <Loading/>
    </div>
  )
}


const PlayerReadyWithNoSideBar = (props) => {
  return (
    <div>
      <div id="ss-video-secion" className="col-md-8 col-md-offset-2">
        <Player config={props.config} isReady={props.isReady} />
        <Menu player={props.player} showSchedule={props.showSchedule} showSubscribe={props.showSubscribe}/>
      </div>
    </div>
  )
}

App.init = function(cb){
  window.Player.getBroadcaster(window.Player.qs.ssId, function() {
    App.getMeta(window.Player.qs.ssId, function(meta){
      App.config = meta
      return cb()
    })
  })
}

App.start = function() {
  App.init(function(){
    window.Player.getVideos(function() {
      var videos = window.Player.videos
      if (App.showSidebar(window.Player)) {
        window.Player.populateUsedCategories(function(){
          ReactDOM.render(<Sidebar videos={videos} />, document.getElementById('ss-sidebar'))
        })
      } else {
        $('#ss-recent-archives-section').hide()
        $('#ss-video-section').addClass('col-md-offset-2')
      }
    })
    window.Player.getUpcomingBroadcasts(function() {
      if (App.showMenu(window.Player)){
        ReactDOM.render(React.createElement(Menu, {}), document.getElementById('ss-menu'))
      } else if(window.Player.video){
        ReactDOM.render(React.createElement(Share, {}), document.getElementById('ss-menu'))
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/components/App.jsx